import React from 'react';
import { Link } from 'react-router-dom';
import SergicLogo from './SergicLogo';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <SergicLogo className="h-16" />
        </div>
        <h1 className="mt-6 text-center text-6xl font-extrabold text-gray-900">
          404
        </h1>
        <h2 className="mt-4 text-center text-2xl font-bold text-gray-900">
          Page non trouvée
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="card text-center">
          <div className="space-y-4">
            <p className="text-gray-600">
              Vous pouvez retourner à l'accueil ou essayer de vous connecter.
            </p>
            <div className="flex flex-col space-y-3">
              <Link
                to="/login"
                className="btn-primary w-full flex justify-center py-2 px-4"
              >
                Se connecter
              </Link>
              <Link
                to="/register"
                className="btn-secondary w-full flex justify-center py-2 px-4"
              >
                Créer un compte
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
